




























































































































































































































import { Component, Prop, Watch, Vue, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import DateField from "@/components/misc/DateField.vue";
import NumericInput from "@/components/misc/NumericInput.vue";
import TimeField from "@/components/misc/TimeField.vue";
import {
  GuestReviewModel,
  GuestReviewStatus,
} from "@/shared/models/guestReview";
import _ from "lodash";
import { Country } from "@/shared/models/country";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";

@Component({
  components: {
    RightDrawer,
    DateField,
    NumericInput,
    TimeField,
  },
})
export default class GuestReviewForm extends Vue {
  @Prop({ default: false }) open!: boolean;
  @Prop() reviewId?: number | null;
  @Prop() callback!: () => any;
  @Prop() guestReviewStatuses?: GuestReviewStatus[];

  fkey = 0;
  saving = false;
  loading = false;

  initialReview: GuestReviewModel = new GuestReviewModel();
  review: GuestReviewModel = new GuestReviewModel();

  @Getter("language/language") language?: string;
  @Getter("codebooks/countries") _countries?: Country[];

  @Getter("globalFilters/properties") _properties?: GlobalFilterProperty[];

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;

      if (fresh && this.reviewId) {
        await this.loadReview();
        this.initialReview = _.cloneDeep(this.review);
      } else {
        this.review = new GuestReviewModel();
        this.initialReview = _.cloneDeep(this.review);
      }
    }
  }
  get countries() {
    if (!this._countries) {
      return [];
    }
    if (this.language === "hr-HR")
      return this._countries.sort((a, b) =>
        a.name > b.name ? 1 : a.name < b.name ? -1 : 0
      );
    else
      return this._countries.sort((a, b) =>
        a.englishName > b.englishName
          ? 1
          : a.englishName < b.englishName
          ? -1
          : 0
      );
  }

  get properties() {
    if (!this._properties) return [];

    return this._properties
      .filter((x) => x.status)
      .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
  }

  async mounted() {
    if (!this.countries || this.countries.length == 0) {
      this.$store.dispatch("codebooks/refreshCountries");
    }
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading && !this.saving;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  countDecimals(num: number) {
    return num.toString().split(".")[1]?.length || 0;
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      oneToTen: (value: any) =>
        value == undefined ||
        value === "" ||
        (value >= 1 && value <= 10) ||
        this.$t("Validation.MustBeFromOneToTen"),
      wholeNumbersOnly: [
        (value: number) =>
          value == null ||
          value == undefined ||
          value % 1 == 0 ||
          this.$t("Validation.MustBeWholeNumber"),
      ],
      maxDecimals: (value: any) =>
        !(this.countDecimals(+value) > 2) ||
        this.$t("Validation.CanOnlyHaveTwoDecimals"),
      maxLength: (max: number) => (value: string) =>
        !value ||
        value.length <= max ||
        this.$t("Validation.MaxLength", { count: max }),
    };
  }

  async loadReview() {
    this.loading = true;
    await Vue.axios
      .get<any>("/guestReviews/" + this.reviewId)
      .then((res) => {
        this.review = res.data;

        const value = new Date(res.data.reviewSubmitDate.substring(0, 10));
        this.review.reviewSubmitDate = value.toISOString().substring(0, 10);

        if (res.data.reviewApprovalDate) {
          const value = new Date(res.data.reviewApprovalDate.substring(0, 10));
          this.review.reviewApprovalDate = value.toISOString().substring(0, 10);
        }
        this.initialReview = _.cloneDeep(this.review);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  refresh() {
    if (this.callback instanceof Function) {
      this.callback();
    }
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  async save() {
    //server returns error for empty string
    if (this.review.reviewApprovalDate === "") {
      this.review.reviewApprovalDate = null;
    }

    if (this.review.id) {
      await this.update();
      return;
    }

    await this.axios
      .post("/guestReviews", { ...this.review })
      .then(() => {
        this.initialReview = _.cloneDeep(this.review);
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GuestReview.SaveSuccess"),
          timeout: 5000,
          localize: true,
        });
        this.$emit("update:open", false);
        this.$emit("callback");
      })
      .finally(() => {
        this.refresh();
      });
  }

  //v-text-field will bind empty string if user deletes value inside of it
  //and we need it to be null - otherwise server returns error that data is wrong
  validateScores() {
    if (_.isEqual(this.review.cleanlinessScore, "")) {
      this.review.cleanlinessScore = null;
    }
    if (_.isEqual(this.review.locationScore, "")) {
      this.review.locationScore = null;
    }
    if (_.isEqual(this.review.valueForMoneyScore, "")) {
      this.review.valueForMoneyScore = null;
    }
    if (_.isEqual(this.review.facilitiesScore, "")) {
      this.review.facilitiesScore = null;
    }
    if (_.isEqual(this.review.staffScore, "")) {
      this.review.staffScore = null;
    }
    if (_.isEqual(this.review.comfortScore, "")) {
      this.review.comfortScore = null;
    }
    if (_.isEqual(this.review.wifiScore, "")) {
      this.review.wifiScore = null;
    }
    return true;
  }

  async update() {
    this.validateScores();
    await this.axios
      .put("/guestReviews/" + this.review.id, { ...this.review })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GuestReview.SaveSuccess"),
          timeout: 5000,
          localize: true,
        });
        this.$emit("update:open", false);
        this.$emit("callback");
      })
      .finally(() => {
        this.refresh();
      });
  }
}
